import amplitude from 'utils/amplitude';
import { EnumAFEvents, EnumEvents, EnumFromName } from 'constants/enums';
import { IProduct } from 'Modules/Products/types';
import { ICurrentOrder } from 'Modules/OrdersHistory/types';
import { IOrder } from 'Modules/Cart/types';
import { OrderStatus } from 'Modules/OrdersHistory/types';
import { convertDashToSpace, calcOrderSize } from './utils';
import { ISomeOrder } from './types';
import analyticsManager from '../tagManager/manager';

export interface IAddedProducts {
  [id: string]: boolean;
}

let addedProductsInCart: IAddedProducts = {};

export const resetAddedProductsAnalytics = () => {
  addedProductsInCart = {};
};

function isAfterCheckout(order: ISomeOrder) {
  return (order as ICurrentOrder).status === OrderStatus.FILLED;
}

function formatForAmplitude(
  product: IProduct,
  order: ISomeOrder,
  from: EnumFromName,
  from_product_page: boolean,
  productsSetId?: number
) {
  const { model_id, name, category_id, price, sale } = product;
  const { id: order_id } = order as IOrder;

  return convertDashToSpace({
    model_id,
    name,
    order_id,
    category_id,
    order_size: calcOrderSize(order),
    from,
    from_product_page,
    ...(productsSetId && { set_id: productsSetId }),
    is_sale: sale,
    price,
    after_checkout: isAfterCheckout(order),
  });
}

export default function addProductInOrderAnalitic(
  product: IProduct,
  order: ISomeOrder,
  from: EnumFromName,
  from_product_page: boolean,
  productsSetId?: number
) {
  const key = `${order.id}_${product.id}`;
  if (!addedProductsInCart[key]) {
    analyticsManager.af(EnumAFEvents.AF_ADD_TO_CART, {
      af_price: product.price,
    });
    amplitude.logEvent(
      EnumEvents.SHOPPING_ADD_PRODUCT,
      formatForAmplitude(product, order, from, from_product_page, productsSetId)
    );
    addedProductsInCart[key] = true;
  }
}
